<div mat-dialog-content>
    <div class="img bottom-margin">
        <img alt="" height="37px" src="https://s3.amazonaws.com/cfa-assets/images/CFA_Circle_Logo.png" width="37px" />
    </div>
    <div class="heading bottom-margin">
        Problem Connecting
    </div>
    <div class="error-content bottom-margin">
        Enterprise Menu Management is temporarily down
    </div>
    <div class="error-content bottom-margin">
        Please Retry
    </div>
</div>
<div mat-dialog-actions>
    <button
        [attr.data-testid]="'cancel_button'"
        class="button-color"
        mat-raised-button
        matTooltip="Cancel"
        (click)="cancel()"
    >Cancel</button>
    <button
        [attr.data-testid]="'retry_button'"
        class="button-color"
        mat-raised-button
        matTooltip="Save"
        (click)="retry()"
    >Retry</button>
</div>
